import support from '../assets/images/ico_support.svg';
import faq from '../assets/images/ico_faq.svg';
import myBooking from '../assets/images/ico_my_booking.svg';
import home from '../assets/images/ico_home.svg';
import back from '../assets/images/ico_back_arrow.svg';
import close from '../assets/images/ico_close.svg'
import vehicle_transport from '../assets/images/ico_vehicle_transport.svg';
import logo from '../assets/images/logo_assistansbolaget.svg';
import company from '../assets/images/ico_company_info.svg';
import noCompany from '../assets/images/ico_company_no_info.svg';
import person from '../assets/images/ico_person_info.svg';
import noPerson from '../assets/images/ico_person_no_info.svg';
import vehicle from '../assets/images/ico_vehicle_info.svg';
import noVehicle from '../assets/images/ico_vehicle_no_info.svg';
import weight from '../assets/images/ico_vehicle_info_weight.svg';
import chevron_down from '../assets/images/ico_chevron_down.svg';
import chevron_up from '../assets/images/ico_chevron_up.svg';
import cost from '../assets/images/ico_cost.svg';
import offer from '../assets/images/ico_offer.svg';
import position from '../assets/images/ico_position.svg';
import route from '../assets/images/ico_route.svg';
import successful from '../assets/images/ico_successful.svg';
import time from '../assets/images/ico_time.svg';
import calendar from '../assets/images/ico_calendar.svg';
import calendar_sm from '../assets/images/ico_calendar_sm.svg';
import time_sm from '../assets/images/ico_time_sm.svg';
import position_sm from '../assets/images/ico_position_sm.svg';
import vehicle_transport_finished from '../assets/images/ico_vehicle_transport_finished.svg';
import ico_location_no_info from '../assets/images/ico_location_no_info.svg';
import ico_my_booking_no_info from '../assets/images/ico_my_booking_no_info.svg';
import ico_date_no_info from '../assets/images/ico_date_no_info.svg';
import ico_error from '../assets/images/ico_error.svg';
import ico_my_booking_empty_info from '../assets/images/ico_my_booking_empty_info.svg';
import ico_external_link from '../assets/images/ico_external_link.svg';
import ico_customer from '../assets/images/ico_customer.svg';
import ico_customer_md from '../assets/images/ico_customer_md.svg';
import ico_customer_lg from '../assets/images/ico_customer_lg.svg';
import ico_customer_no_info from '../assets/images/ico_customer_no_info.svg';
import ico_customer_info from '../assets/images/ico_customer_info.svg';



export function images(img: string) {

    let image;
    if (img === 'ico_my_booking') {
        image = myBooking
    } else if (img === 'ico_faq') {
        image = faq
    } else if (img === 'ico_support') {
        image = support
    } else if (img === 'ico_home') {
        image = home
    } else if (img === 'ico_back_arrow') {
        image = back
    } else if (img === 'ico_close') {
        image = close
    } else if (img === 'logo_assistansbolaget') {
        image = logo
    } else if (img === 'ico_vehicle_transport') {
        image = vehicle_transport
    } else if (img === 'ico_company_no_info') {
        image = noCompany
    } else if (img === 'ico_company_info') {
        image = company
    } else if (img === 'ico_person_info') {
        image = person
    } else if (img === 'ico_person_no_info') {
        image = noPerson
    } else if (img === 'ico_vehicle_info_weight') {
        image = weight
    } else if (img === 'ico_vehicle_info') {
        image = vehicle
    } else if (img === 'ico_vehicle_no_info') {
        image = noVehicle
    } else if (img === 'ico_chevron_down') {
        image = chevron_down
    } else if (img === 'ico_chevron_up') {
        image = chevron_up
    } else if (img === 'ico_cost') {
        image = cost
    } else if (img === 'image.ico_offer') {
        image = offer
    } else if (img === 'ico_position') {
        image = position
    } else if (img === 'ico_route') {
        image = route
    } else if (img === 'ico_successful') {
        image = successful
    } else if (img === 'ico_time') {
        image = time
    } else if (img === 'ico_vehicle_transport_finished') {
        image = vehicle_transport_finished
    } else if (img === 'ico_calendar') {
        image = calendar
    } else if (img === 'ico_calendar_sm') {
        image = calendar_sm
    } else if (img === 'ico_time_sm') {
        image = time_sm
    } else if (img === 'ico_position_sm') {
        image = position_sm
    } else if (img === 'image.ico_location_no_info') {
        image = ico_location_no_info
    } else if (img === 'image.ico_my_booking_no_info') {
        image = ico_my_booking_no_info
    } else if (img === 'ico_date_no_info') {
        image = ico_date_no_info
    } else if (img === 'ico_error') {
        image = ico_error
    } else if (img === 'image.ico_my_booking_empty_info') {
        image = ico_my_booking_empty_info
    } else if (img === 'ico_external_link') {
        image = ico_external_link
    } else if (img === 'ico_customer') {
        image = ico_customer
    } else if (img === 'ico_customer_md') {
        image = ico_customer_md
    } else if (img === 'ico_customer_lg') {
        image = ico_customer_lg
    } else if (img === 'ico_customer_no_info') {
        image = ico_customer_no_info
    }else if (img === 'ico_customer_info') {
        image = ico_customer_info
    }

    return image
}